export default {"src":"https://cloudflare.edhrec.com/_next/static/media/manabrg.6d3a42e5.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};